import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-close\">\n<path d=\"M150.5,27.8l-42.8,42.8c-4.2,4.2-10.9,4.2-14.8,0l-43-42.8c-6.1-6.1-15.9-6.1-21.9,0l0,0c-6.1,6.1-6.1,15.9,0,21.9\n\tl42.8,42.8c4.2,4.2,4.2,10.9,0,14.8l-42.8,42.8c-6.1,6.1-6.1,15.9,0,21.9l0,0c6.1,6.1,15.9,6.1,21.9,0l42.8-42.8\n\tc4.2-4.2,10.9-4.2,14.8,0l42.8,42.8c6.1,6.1,15.9,6.1,21.9,0l0,0c6.1-6.1,6.1-15.9,0-21.9l-42.8-42.8c-4.2-4.2-4.2-10.9,0-14.8\n\tl42.8-42.8c6.1-6.1,6.1-15.9,0-21.9l0,0C166.3,21.8,156.5,21.8,150.5,27.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/close.svg
// module id = toIl
// module chunks = 3